import React from 'react';
import { Form, Input, Modal, notification } from 'antd';
import { PricingAPI } from '../../controller/PricingAPI';

export default function ChangePasswordModal({ visible, onClose }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = React.useState(false);

  const handleOk = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch (e) {
      return; // 欄位驗證未過，由表單自行顯示錯誤
    }

    setSubmitting(true);
    try {
      await PricingAPI.auth.updatePassword(
        values.current_password,
        values.password,
        values.password_confirmation
      );
      notification.success({ message: '密碼已更新', description: '其他裝置需要重新登入' });
      form.resetFields();
      onClose();
    } catch (error) {
      // 後端於舊密碼錯誤時回傳 422 與中文訊息，直接顯示給使用者
      notification.error({
        message: '修改失敗',
        description: error?.response?.data?.message || '請稍後再試',
      });
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="修改密碼"
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={submitting}
      okText="確認"
      cancelText="取消"
      destroyOnClose
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          label="目前密碼"
          name="current_password"
          rules={[{ required: true, message: '請輸入目前密碼' }]}
        >
          <Input.Password autoComplete="current-password" />
        </Form.Item>
        <Form.Item
          label="新密碼"
          name="password"
          rules={[
            { required: true, message: '請輸入新密碼' },
            { min: 8, message: '密碼至少 8 碼' },
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          label="確認新密碼"
          name="password_confirmation"
          dependencies={['password']}
          rules={[
            { required: true, message: '請再次輸入新密碼' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('兩次輸入的密碼不一致'));
              },
            }),
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
